module.exports = __webpack_public_path__ + "static/media/(V)-Artesanato-14.d61822c0.jpg";